import React, { useCallback, useMemo, useState } from 'react'
import noop from 'lodash/noop'
import { ANGEL_GUILD_PREMIUM_YEARLY_OFFER_ID } from '@/constants/offer-ids'
import { ReactFCC } from '@/types/react'

interface GuildSubscriptionCheckoutProviderProps {
  offerId: string
  isGuildMember: boolean
}

interface GuildSubscriptionCheckoutState {
  isGuildMember: boolean
  isGuildSubscriptionComplete: boolean
  onComplete: () => void
  isYearly: boolean
}

const GuildSubscriptionCheckoutContext = React.createContext<GuildSubscriptionCheckoutState>({
  isGuildSubscriptionComplete: false,
  onComplete: noop,
  isYearly: false,
  isGuildMember: false,
})

export const GuildSubscriptionCheckoutProvider: ReactFCC<GuildSubscriptionCheckoutProviderProps> = ({
  children,
  offerId,
  isGuildMember,
}) => {
  const [isGuildSubscriptionComplete, setGuildSubscriptionComplete] = useState(false)

  const onComplete = useCallback(() => {
    setGuildSubscriptionComplete(true)
  }, [setGuildSubscriptionComplete])

  const value = useMemo(
    () => ({
      isGuildMember,
      isGuildSubscriptionComplete,
      onComplete,
      isYearly: offerId === ANGEL_GUILD_PREMIUM_YEARLY_OFFER_ID,
    }),
    [isGuildMember, isGuildSubscriptionComplete, onComplete, offerId],
  )

  return <GuildSubscriptionCheckoutContext.Provider value={value}>{children}</GuildSubscriptionCheckoutContext.Provider>
}

export const useGuildSubscriptionContext = (): GuildSubscriptionCheckoutState => {
  return React.useContext(GuildSubscriptionCheckoutContext)
}
